module.exports = __webpack_public_path__ + "img/deer.357c35d4.png";